var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aha-share-gigya',[[_c('aha-recipe-social',{attrs:{"write-review-label":"Rate This Recipe","ratings-category-id":"Recipe","ratings-stream-id":"2163","comments-category-id":"Recipe","comments-stream-id":"2074","comments-stream-tags":"globalRecipe, 1002/4021, 1003/4031, 1004/4033, 1002/4023, 1001/4017, 1001/4018, 1002/4025, 1002/4024, 1002/4028, 1000/4011"}})]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03a56da6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./demo/components/recipe/social.vue
// module id = 1250
// module chunks = 0